import { action, observable, makeObservable } from 'mobx';

export class ModalStore {
	@observable isOpen = false;
	@observable title;
	@observable className = '';
	@observable isV2 = false;
	@observable.ref modalComponent = null;

	constructor() {
		makeObservable(this);
	}

	@action
	openModal(options, modalComponent) {
		this.isOpen = true;
		this.title = options.title;
		this.saveButtonLabel = options.saveButtonLabel;
		this.position = this.getPositionClass(options.position);
		this.size = this.getSizeClass(options.size);
		this.modalComponent = modalComponent;
		// Detect if it's a V2 modal by checking the options or component type
		this.isV2 = options.isV2 || this.isModalComponentV2(modalComponent);
		document.body.classList.add('no-scroll');
	}

	getPositionClass(position) {
		if (
			position === 'Center' ||
			position === 'centered' ||
			position === 'center'
		) {
			return 'is-centered';
		}
		return '';
	}

	getSizeClass(size) {
		if (size === 'XL' || size === 'xl') {
			return 'is-xl';
		}

		if (size === '2xl') {
			return 'is-2xl';
		}
		return '';
	}

	@action
	closeDialog() {
		this.isOpen = false;
		this.title = null;
		this.className = '';
		this.saveButtonLabel = null;
		this.isV2 = false;
		setTimeout(
			action(() => {
				this.modalComponent = null;
				document.body.classList.remove('no-scroll');
			}),
			100
		);
	}

	isModalComponentV2(modalComponent) {
		if (!modalComponent || !modalComponent.type) {
			return false;
		}

		// Check if component has static isV2 property or props specify isV2
		return (
			modalComponent.type.isV2 === true ||
			(modalComponent.props && modalComponent.props.isV2 === true)
		);
	}

	getModalComponent() {
		return this.isOpen ? modalStore.modalComponent : null;
	}
}

const modalStore = new ModalStore();
export { modalStore };
